/* import React from "react";

const LoaderLine = ({isLoading}) => {
  if (!isLoading) return <></>

  return <div class="loader-line"></div>
} */

import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

class LoaderLine extends Component {

  componentWillUnmount(){

  }
  
  componentDidMount(){ 
  }



  render() {

    if (!this.props.dev.isLoading) return <></>
    
    return (
      <div class="loader-line"></div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
  };
}

  const mapDispatchToProps = { 
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(LoaderLine);
